import React from "react";
import DHButtonIcon from "./DHButtonIcon";
import CheckIcon from '@mui/icons-material/Check';

export default function DHButtonIconCheck({ disabled, onClick}) {

    return <DHButtonIcon icon={<CheckIcon/>} disabled={disabled} onClick={onClick}/>
}